import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "src/common/state/hooks";
import { PROJECT_GROUP_LIST_COMPONENT_ID } from "src/features/projectGroups/components/ProjectGroupList";
import type { IProjectGroupWithProjects } from "src/features/projectGroups/state/projectGroupsSlice";
import {
  fetchAllCurrentElements,
  getProjectGroupPermissionsFromServer,
  setCurrentProjectGroupPermissions,
  setSelectedProjectGroup,
  setSelectedProjectGroupFromId,
} from "src/features/projectGroups/state/projectGroupsSlice";
import { getProjectTemplates } from "src/features/projects/state/projectsSlice";

export const useOpenNewModuleWizard = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return useCallback(
    (projectGroup: IProjectGroupWithProjects) => {
      const projectGroupId = Number(projectGroup.id);
      void dispatch(getProjectTemplates({ componentId: "projectTemplateComponent" }));
      dispatch(setSelectedProjectGroupFromId(projectGroupId));
      void dispatch(
        fetchAllCurrentElements({
          projectGroupId,
          componentId: PROJECT_GROUP_LIST_COMPONENT_ID,
        }),
      );
      dispatch(setSelectedProjectGroup(projectGroup));
      void dispatch(getProjectGroupPermissionsFromServer({ projectGroupId })).then((res) => {
        if (!getProjectGroupPermissionsFromServer.fulfilled.match(res)) {
          return;
        }
        dispatch(setCurrentProjectGroupPermissions(res.payload.data));
      });
      navigate(`/courses/${projectGroup.id}/new`);
    },
    [dispatch, navigate],
  );
};
